import { render, staticRenderFns } from "./CardAvatar.vue?vue&type=template&id=abf1f9b0&scoped=true"
import script from "./CardAvatar.vue?vue&type=script&lang=ts"
export * from "./CardAvatar.vue?vue&type=script&lang=ts"
import style0 from "./CardAvatar.vue?vue&type=style&index=0&id=abf1f9b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf1f9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abf1f9b0')) {
      api.createRecord('abf1f9b0', component.options)
    } else {
      api.reload('abf1f9b0', component.options)
    }
    module.hot.accept("./CardAvatar.vue?vue&type=template&id=abf1f9b0&scoped=true", function () {
      api.rerender('abf1f9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardAvatar.vue"
export default component.exports